import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainNavItems } from '../constants';
import { ProfileIcon } from './Icons';

const BottomNav: React.FC = () => {
    const { t } = useTranslation();

    const allNavItems = [
        ...mainNavItems,
        { href: '/profile', labelKey: 'nav.profile', icon: <ProfileIcon variant="stroke"/> }
    ];

    return (
        <footer className="fixed bottom-0 left-0 right-0 z-30 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border-t border-gray-200 dark:border-gray-800">
            <nav className="mx-auto max-w-7xl flex items-center justify-around px-2 py-2">
                {allNavItems.map(item => (
                    <NavLink
                        key={item.labelKey}
                        to={item.href}
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center gap-1 w-full py-1 rounded-lg transition-colors ${
                                isActive ? 'text-[var(--primary-color)]' : 'text-gray-500 dark:text-gray-400 hover:text-[var(--primary-color)]'
                            }`
                        }
                    >
                        {item.icon}
                        <span className="text-xs font-medium">{t(item.labelKey)}</span>
                    </NavLink>
                ))}
            </nav>
        </footer>
    );
};

export default BottomNav;
